import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const StrandedItemsListView = lazy(() => import('./components/views/StrandedItemsListView'));

/**
 * Admin-only routes for the global stranded-items dashboard.
 * Visible to users with the Admin role.
 */
const strandedItemsRoutes: FuseRouteItemType[] = [
	{
		path: 'stranded-items',
		auth: ['Admin'],
		children: [
			{
				path: '',
				element: <StrandedItemsListView />
			}
		]
	}
];

export default strandedItemsRoutes;
